<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="companyUsers"
      :items-per-page="50"
      class="elevation-1"
    >
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ humanDate(item.createdAt, "dd MMM yyyy - HH:mm") }}
      </template>
      <template v-slot:[`item.role`]="{ item }">
        <v-select
          v-on:change="updateUserRole(item)"
          v-model="item.role"
          :items="roles"
          :disabled="!allowedToEdit(currentUser.role, item.role)"
          :label="$t('user.role')"
          v-if="item.role !== 'SuperAdmin'"
        ></v-select>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          dark
          color="primary"
          @click="clickedRow(item)"
          v-if="
            item.userId === currentUser.userId ||
            allowedToEdit(currentUser.role, item.role)
          "
          >edit</v-icon
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Roles } from "@/_helpers/Role";

export default {
  name: "CompanyUsers",

  data() {
    return {
      roles: [
        { text: Roles.Admin, value: Roles.Admin, disabled: true },
        { text: Roles.CompanyAdmin, value: Roles.CompanyAdmin },
        { text: Roles.User, value: Roles.User },
      ],
      disabledRoles: [Roles.Admin],
      headers: [
        { text: this.$t("user.email"), value: "email" },
        { text: this.$t("common.createdAt"), value: "createdAt" },
        { text: this.$t("user.role"), value: "role" },
        { text: this.$t("user.edit"), value: "actions" },
      ],
    };
  },
  computed: {
    ...mapState("users", [
      "status",
      "currentUser",
      "userCompany",
      "hasCompany",
    ]),
    ...mapState("companies", ["companyUsers"]),
  },
  methods: {
    ...mapActions("companies", ["getCompanyUsers"]),
    ...mapActions("users", ["updateRole", "getById"]),

    updateUserRole(item) {
      if (item.role == "Admin" && this.currentUser.role != Roles.Admin)
        this.$router.push("/");

      this.updateRole({ role: item.role, targetUserId: item.userId });
    },

    async clickedRow(item) {
      if (
        item.userId === this.currentUser.userId ||
        (this.allowed(null, Roles.AdminOrCompanyAdmin) &&
          this.allowedToEdit(this.currentUser.role, item.role))
      ) {
        await this.getById(item.userId);
        this.$router.push(`/company/user/${item.userId}`);
      }
    },
  },
  created() {
    if (this.hasCompany) this.getCompanyUsers();
    else this.$route.push("/404");
  },
};
</script>

<style></style>
